import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CardComponent } from '../../../../shared/components/card/card.component';
import { IconComponent } from '../../../../shared/icons/icon.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import {
  ConfirmDialogComponent,
  ConfirmDialogData,
} from '../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { filter, Observable, take, takeLast } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { AsyncPipe } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-system-stop',
  imports: [CardComponent, IconComponent, TranslatePipe, AsyncPipe, MatTooltip],
  templateUrl: './system-stop.component.html',
  styleUrl: './system-stop.component.scss',
})
export class SystemStopComponent {
  private dialog = inject(MatDialog);
  private translateService = inject(TranslateService);

  @Input() isSystemRunning$!: Observable<boolean>;
  @Input() isEmegancyStopActive$!: Observable<boolean>;
  @Input() type: 'dashboard' | 'global' = 'global';
  @Output() triggerKillSwitch: EventEmitter<boolean> = new EventEmitter();

  onToggleSystem(isSystemRunning: boolean | null) {
    this.isEmegancyStopActive$.pipe(take(1)).subscribe((isActive) => {
      if (isActive) {
        const dialogData: ConfirmDialogData = {
          title: this.translateService.instant(
            'dashboard.systemStop.emergancyStop.title',
          ),
          body: this.translateService.instant(
            'dashboard.systemStop.emergancyStop.body',
          ),
          hint: this.translateService.instant(
            'dashboard.systemStop.emergancyStop.hint',
          ),
          confirmLabel: this.translateService.instant('default.ok'),
          action: 'danger',
        };

        this.dialog.open(ConfirmDialogComponent, {
          data: dialogData,
        });

        return;
      }

      if (isSystemRunning) {
        this.onStopSystem();
      } else {
        this.onStartSystem();
      }
    });
  }

  onStopSystem() {
    const dialogData: ConfirmDialogData = {
      title: this.translateService.instant('dashboard.systemStop.stop.title'),
      body: this.translateService.instant('dashboard.systemStop.stop.body'),
      hint: this.translateService.instant('dashboard.systemStop.stop.hint'),
      confirmLabel: this.translateService.instant(
        'dashboard.systemStop.stop.label',
      ),
    };

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: dialogData,
    });

    dialogRef
      .afterClosed()
      .pipe(
        take(1),
        filter((result): result is true => result === true),
      )
      .subscribe(() => {
        this.triggerKillSwitch.emit(true);
      });
  }

  onStartSystem() {
    this.triggerKillSwitch.emit(false);
  }
}
